import { z } from 'zod';

const rewardSortValidation = z
  .enum(['name', 'popularity', 'promotional_amount', 'created_at'])
  // catch will handle null cases, since default only handles undefined cases
  .catch('popularity')
  .default('popularity');

const rewardDiningSortValidation = z
  .enum(['distance', 'promotional_amount', 'created_at'])
  .catch('distance')
  .default('distance');

export { rewardDiningSortValidation, rewardSortValidation };
